<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        01.28
        <br>2020
      </span>
      <span class="tiel">美菜优先保障武汉及全国防疫一线餐饮供应的公告</span>
    </div>
    <div class="mat-content">
      <br>
      <br>
      <p align="center">
        <img src="@/assets/images/new-img/new0309/a0309_4.png" width="640">
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
